export default __webpack_public_path__ + "static/media/2FFAAE97-545C-4595-9702-FFC17D5C242C_1_105_c.aee3245e.jpeg";